import React from 'react';
import ReactDOM from 'react-dom';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'core-js';
import './polyfill';
import './tailwind.css';

import App from './App';
import { queryClient } from './services/queryClient';

import { icons } from './assets/icons';
import { Provider } from 'react-redux';
import store from './store';

import * as Sentry from '@sentry/react';

if (process.env.REACT_APP_SENTRY_ENABLED === 'true') {
  Sentry.init({
    dsn: 'https://16b0ed2a987ca341017d83e7e5f5ab20@o4508251248001024.ingest.us.sentry.io/4508263626571776',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.1,
    tracePropagationTargets: [/^https:\/\/admin\.mapadaprova\.com\.br/],
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 1.0,
  });
}

React.icons = icons

ReactDOM.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </Provider>,
  document.getElementById('root')
);
